<template>
    <div class="ppv2-space-y-4">
        <InfoMessageBox
            class="ppv2-mt-2"
            :title="$t('messageBox.paymentPrepaidSolutions.start.title')"
            color="info"
            :customIcon="customIconStart"
        />

        <div class="ppv2-flex ppv2-flex-col ppv2-space-y-4">
            <div class="ppv2-relative ppv2-p-4 ppv2-cursor-pointer">
                <div class="ppv2-absolute ppv2-top-2 ppv2-right-2">
                    <BaseSwitch
                        v-model="formData.gift_enabled"
                        required
                        :disabled="false"
                        :error="hasError ? $t('prepaidSolutionsConfiguration.fields.giftEnabled.error') : ''"
                    />
                </div>
                <div>
                    <div class="ppv2-text-base ppv2-text-gray-800 poppinsMedium">
                        <BaseLabel :label="$t('prepaidSolutionsConfiguration.fields.giftEnabled.label')" />
                    </div>
                    <div class="ppv2-flex ppv2-items-center ppv2-space-x-2 ppv2-mt-1 ppv2-text-xs ppv2-text-gray-500">
                        <BaseParagraphe>
                            {{ $t('prepaidSolutionsConfiguration.fields.giftEnabled.description') }}
                        </BaseParagraphe>
                    </div>
                </div>
                <BaseInput
                    v-model="formData.voucher_duree"
                    :label="$t('prepaidSolutionsConfiguration.fields.prepaidVoucher.label')"
                    :description="$t('prepaidSolutionsConfiguration.fields.prepaidVoucher.description')"
                    class="ppv2-mt-4"
                    placeholder="365"
                    :tooltipMsg="$t('prepaidSolutionsConfiguration.fields.prepaidVoucher.tool_tip_msg')"
                    required
                >
                    <template #leftIcon>
                        <svg
                            class="ppv2-w-4 ppv2-h-4 ppv2-text-gray-700"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8 2.5V6.5M16 2.5V6.5M21 14.5V6.5C21 5.96957 20.7893 5.46086 20.4142 5.08579C20.0391 4.71071 19.5304 4.5 19 4.5H5C4.46957 4.5 3.96086 4.71071 3.58579 5.08579C3.21071 5.46086 3 5.96957 3 6.5V20.5C3 21.0304 3.21071 21.5391 3.58579 21.9142C3.96086 22.2893 4.46957 22.5 5 22.5H13M3 10.5H21M16 20.5L18 22.5L22 18.5"
                                stroke="#021832"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </template>
                </BaseInput>
                <BaseInput
                    v-model="formData.ticket_valid_days"
                    :label="$t('prepaidSolutionsConfiguration.fields.prepaidUndatedTicket.label')"
                    :description="$t('prepaidSolutionsConfiguration.fields.prepaidUndatedTicket.description')"
                    class="ppv2-mt-4"
                    placeholder="180"
                    :tooltipMsg="$t('prepaidSolutionsConfiguration.fields.prepaidUndatedTicket.tool_tip_msg')"
                    required
                >
                    <template #leftIcon>
                        <svg
                            class="ppv2-w-4 ppv2-h-4 ppv2-text-gray-700"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8 2.5V6.5M16 2.5V6.5M21 14.5V6.5C21 5.96957 20.7893 5.46086 20.4142 5.08579C20.0391 4.71071 19.5304 4.5 19 4.5H5C4.46957 4.5 3.96086 4.71071 3.58579 5.08579C3.21071 5.46086 3 5.96957 3 6.5V20.5C3 21.0304 3.21071 21.5391 3.58579 21.9142C3.96086 22.2893 4.46957 22.5 5 22.5H13M3 10.5H21M16 20.5L18 22.5L22 18.5"
                                stroke="#021832"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </template>
                </BaseInput>

                <BaseLabel :label="$t('prepaidSolutionsConfiguration.fields.prepaidPackages.label')" class="ppv2-mt-4" />
                <InfoMessageBox
                    class="ppv2-mt-2"
                    :message="$t('prepaidSolutionsConfiguration.fields.prepaidPackages.message')"
                    color="info"
                />

                <BaseLabel
                    :label="$t('prepaidSolutionsConfiguration.fields.prepaidActiveSubscriptions.label')"
                    class="ppv2-mt-4"
                />
                <InfoMessageBox
                    class="ppv2-mt-2"
                    :message="$t('prepaidSolutionsConfiguration.fields.prepaidActiveSubscriptions.message')"
                    color="info"
                />
            </div>
        </div>
    </div>
</template>

<script>
import InfoMessageBox from '../../../Shared/InfoMessageBox.vue'
import BaseParagraphe from '../../../Shared/BaseParagraphe.vue'
import BaseRadioGroup from '../../../Shared/BaseRadioGroup.vue'
import BaseSwitch from '../../../Shared/BaseSwitch.vue'
import BaseLabel from '../../../Shared/BaseLabel.vue'
import BaseInput from '../../../Shared/BaseInput.vue'

export default {
    name: 'PaymentPrepaidSolutions',
    props: {
        giftEnabled: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        InfoMessageBox,
        BaseParagraphe,
        BaseRadioGroup,
        BaseSwitch,
        BaseLabel,
        BaseInput,
    },
    data() {
        return {
            customIconStart: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 5.5V7.5M13 17.5V19.5M13 11.5V13.5M2 9.5C2.79565 9.5 3.55871 9.81607 4.12132 10.3787C4.68393 10.9413 5 11.7044 5 12.5C5 13.2956 4.68393 14.0587 4.12132 14.6213C3.55871 15.1839 2.79565 15.5 2 15.5V17.5C2 18.0304 2.21071 18.5391 2.58579 18.9142C2.96086 19.2893 3.46957 19.5 4 19.5H20C20.5304 19.5 21.0391 19.2893 21.4142 18.9142C21.7893 18.5391 22 18.0304 22 17.5V15.5C21.2044 15.5 20.4413 15.1839 19.8787 14.6213C19.3161 14.0587 19 13.2956 19 12.5C19 11.7044 19.3161 10.9413 19.8787 10.3787C20.4413 9.81607 21.2044 9.5 22 9.5V7.5C22 6.96957 21.7893 6.46086 21.4142 6.08579C21.0391 5.71071 20.5304 5.5 20 5.5H4C3.46957 5.5 2.96086 5.71071 2.58579 6.08579C2.21071 6.46086 2 6.96957 2 7.5V9.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
            customIconLink: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 3H21M21 3V9M21 3L10 14M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
            isActive: false,
            hasError: false,
            formData: {
                voucher_duree: 365,
                ticket_valid_days: 180,
                gift_enabled: false,
            },
        }
    },
    computed: {
        establishment() {
            return this.$store.getters['establishment/establishment']
        },
        modeOptions() {
            return [
                {
                    label: this.$t('configuration.paymentPrepaidSolutions.fields.stripeMode.options.production.label'),
                    description: this.$t(
                        'configuration.paymentPrepaidSolutions.fields.stripeMode.options.production.description'
                    ),
                    value: false,
                },
                {
                    label: this.$t('configuration.paymentPrepaidSolutions.fields.stripeMode.options.sandbox.label'),
                    description: this.$t('configuration.paymentPrepaidSolutions.fields.stripeMode.options.sandbox.description'),
                    value: true,
                },
            ]
        },
    },
    watch: {
        establishment: {
            handler() {
                this.initializeForm()
            },
            immediate: true,
            deep: true,
        },
        giftEnabled: {
            handler() {
                this.initializeForm()
            },
            immediate: true,
        },
        formData: {
            handler(newVal) {
                // Convert gift_enabled boolean to "on"/"off" for both enabled_bon_cadeau and enabled_menu_gift
                const updatedData = { ...newVal }
                if ('gift_enabled' in updatedData) {
                    updatedData.finalGiftValue = updatedData.gift_enabled ? 'on' : 'off'
                    delete updatedData.gift_enabled // Remove the temporary field
                }
                this.$emit('update', updatedData)
            },
            deep: true,
        },
    },
    methods: {
        initializeForm() {
            const fields = ['voucher_duree', 'ticket_valid_days']
            fields.forEach((field) => {
                if (this.establishment.hasOwnProperty(field)) {
                    this.formData[field] = this.establishment[field]
                }
            })

            if (this.establishment.hasOwnProperty('finalGiftValue')) {
                this.formData.gift_enabled = this.establishment.finalGiftValue === 'on'
            } else {
                this.formData.gift_enabled = this.giftEnabled
            }
        },
    },
}
</script>

<style scoped></style>
